import { miraMainTabs, type MiraMainTabId } from '@mira/clients-shared';
import { hrefForRoute } from '../app/router.js';
import { MiraIcon } from '../ui/primitives/index.js';

export function BottomTabs(props: { active?: MiraMainTabId }) {
  return (
    <nav className="mira-bottom-tabs" aria-label="Primary navigation">
      {miraMainTabs.map((tab) => (
        <a className="mira-bottom-tab" data-active={props.active === tab.id || undefined} href={hrefForRoute(tab.routeId)} key={tab.id}>
          <span className="mira-bottom-tab-icon" aria-hidden="true"><MiraIcon name={tabIconName(tab.id)} /></span>
          <span>{tab.label}</span>
        </a>
      ))}
    </nav>
  );
}

function tabIconName(tab: MiraMainTabId) {
  if (tab === 'today') return 'nav.today';
  if (tab === 'topics') return 'nav.topics';
  if (tab === 'relationships') return 'nav.relationships';
  return 'nav.memory';
}
